/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * All possible FHIR ActPriority codes.
 */
export enum ActPriority {
  A = "A",
  CR = "CR",
  EL = "EL",
  EM = "EM",
  P = "P",
  PRN = "PRN",
  R = "R",
  RR = "RR",
  S = "S",
  T = "T",
  UD = "UD",
  UR = "UR",
}

/**
 * All possible FHIR action participant function codes.
 */
export enum ActionParticipantFunction {
  AUTHOR = "AUTHOR",
  PERFORMER = "PERFORMER",
  REVIEWER = "REVIEWER",
  WITNESS = "WITNESS",
}

/**
 * All possible FHIR action required behavior codes.
 */
export enum ActionRequiredBehavior {
  COULD = "COULD",
  MUST = "MUST",
  MUST_UNLESS_DOCUMENTED = "MUST_UNLESS_DOCUMENTED",
}

/**
 * All Application API actions.
 */
export enum AppActions {
  Create = "Create",
  Delete = "Delete",
  Read = "Read",
  Restore = "Restore",
  Update = "Update",
}

/**
 * All possible appointment statuses
 */
export enum AppointmentStatus {
  ARRIVED = "ARRIVED",
  BOOKED = "BOOKED",
  CANCELLED = "CANCELLED",
  CHECKED_IN = "CHECKED_IN",
  ENTERED_IN_ERROR = "ENTERED_IN_ERROR",
  FULFILLED = "FULFILLED",
  NO_SHOW = "NO_SHOW",
  PENDING = "PENDING",
  WAITLIST = "WAITLIST",
}

/**
 * All possible appointment types
 */
export enum AppointmentType {
  CHECKUP = "CHECKUP",
  EMERGENCY = "EMERGENCY",
  FOLLOWUP = "FOLLOWUP",
  ROUTINE = "ROUTINE",
  WALK_IN = "WALK_IN",
}

/**
 * All possible event types for calendar
 */
export enum CalendarEventTypes {
  APPOINTMENTS = "APPOINTMENTS",
  BUSINESS = "BUSINESS",
  ETC = "ETC",
  PERSONAL = "PERSONAL",
}

/**
 * All possible FHIR group type codes
 */
export enum CareGroupTypes {
  ANIMAL = "ANIMAL",
  CARE_TEAM = "CARE_TEAM",
  DEVICE = "DEVICE",
  HEALTHCARE_SERVICE = "HEALTHCARE_SERVICE",
  LOCATION = "LOCATION",
  ORGANIZATION = "ORGANIZATION",
  PERSON = "PERSON",
  PRACTITIONER = "PRACTITIONER",
  RELATED_PERSON = "RELATED_PERSON",
  SPECIMEN = "SPECIMEN",
}

/**
 * All possible FHIR Care team category codes.
 */
export enum CareTeamCategory {
  ENCOUNTER = "ENCOUNTER",
  EPISODE_OF_CARE = "EPISODE_OF_CARE",
  EVENT = "EVENT",
  HCBS = "HCBS",
  LONGITUDINAL = "LONGITUDINAL",
  PUBLIC_HEALTH = "PUBLIC_HEALTH",
  RESEARCH = "RESEARCH",
}

/**
 * All possible FHIR Care team status codes
 */
export enum CareTeamStatus {
  ACTIVE = "ACTIVE",
  ENTERED_IN_ERROR = "ENTERED_IN_ERROR",
  INACTIVE = "INACTIVE",
  PROPOSED = "PROPOSED",
  SUSPENDED = "SUSPENDED",
}

/**
 * All available FHIR condition category codes.
 */
export enum ConditionCategoryCodes {
  ENCOUNTER_DIAGNOSIS = "ENCOUNTER_DIAGNOSIS",
  PROBLEM_LIST_ITEM = "PROBLEM_LIST_ITEM",
}

/**
 * All available FHIR condition clinical statuses
 */
export enum ConditionClinicalStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  RECURRENCE = "RECURRENCE",
  RELAPSE = "RELAPSE",
  REMISSION = "REMISSION",
  RESOLVED = "RESOLVED",
  UNKNOWN = "UNKNOWN",
}

/**
 * All possible FHIR condition codes.
 */
export enum ConditionCodes {
  ANXIETY_DISORDER = "ANXIETY_DISORDER",
  CHOROIDAL_HEMORRHAGE = "CHOROIDAL_HEMORRHAGE",
  CLINICAL_FINDING = "CLINICAL_FINDING",
}

/**
 * All available FHIR condition severity codes.
 */
export enum ConditionSeverityCodes {
  MILD = "MILD",
  MODERATE = "MODERATE",
  SEVERE = "SEVERE",
  UNKNOWN = "UNKNOWN",
}

/**
 * All available FHIR condition verification status codes.
 */
export enum ConditionVerificationStatus {
  CONFIRMED = "CONFIRMED",
  DIFFERENTIAL = "DIFFERENTIAL",
  ENTERED_IN_ERROR = "ENTERED_IN_ERROR",
  PROVISIONAL = "PROVISIONAL",
  REFUTED = "REFUTED",
  UNCONFIRMED = "UNCONFIRMED",
}

/**
 * All available FHIR DetectedIssue category codes.
 */
export enum DetectedIssueCategory {
  ABUSE = "ABUSE",
  ADALRT = "ADALRT",
  AGE = "AGE",
  ALGY = "ALGY",
  ALLDONE = "ALLDONE",
  COMPLY = "COMPLY",
  COND = "COND",
  CREACT = "CREACT",
  DACT = "DACT",
  DOSE = "DOSE",
  DOSECOND = "DOSECOND",
  DOSEDUR = "DOSEDUR",
  DOSEDURH = "DOSEDURH",
  DOSEDURHIND = "DOSEDURHIND",
  DOSEDURL = "DOSEDURL",
  DOSEDURLIND = "DOSEDURLIND",
  DOSEH = "DOSEH",
  DOSEHIND = "DOSEHIND",
  DOSEHINDA = "DOSEHINDA",
  DOSEHINDSA = "DOSEHINDSA",
  DOSEHINDW = "DOSEHINDW",
  DOSEIVL = "DOSEIVL",
  DOSEIVLIND = "DOSEIVLIND",
  DOSEL = "DOSEL",
  DOSELIND = "DOSELIND",
  DOSELINDA = "DOSELINDA",
  DOSELINDSA = "DOSELINDSA",
  DOSELINDW = "DOSELINDW",
  DRG = "DRG",
  DUPTHPCLS = "DUPTHPCLS",
  DUPTHPGEN = "DUPTHPGEN",
  DUPTHPY = "DUPTHPY",
  ENDLATE = "ENDLATE",
  FOOD = "FOOD",
  FRAUD = "FRAUD",
  FULFIL = "FULFIL",
  GEALRT = "GEALRT",
  GEN = "GEN",
  HELD = "HELD",
  HISTORIC = "HISTORIC",
  INT = "INT",
  INTERVAL = "INTERVAL",
  LACT = "LACT",
  MDOSE = "MDOSE",
  MINFREQ = "MINFREQ",
  NHP = "NHP",
  NONRX = "NONRX",
  NOTACTN = "NOTACTN",
  NOTEQUIV = "NOTEQUIV",
  NOTEQUIVGEN = "NOTEQUIVGEN",
  NOTEQUIVTHER = "NOTEQUIVTHER",
  OBSA = "OBSA",
  PATPREF = "PATPREF",
  PATPREFALT = "PATPREFALT",
  PEALRT = "PEALRT",
  PLYDOC = "PLYDOC",
  PLYPHRM = "PLYPHRM",
  PREG = "PREG",
  PREVINEF = "PREVINEF",
  RALG = "RALG",
  RAR = "RAR",
  RINT = "RINT",
  RREACT = "RREACT",
  STRTLATE = "STRTLATE",
  TIME = "TIME",
  TIMING = "TIMING",
  TOOLATE = "TOOLATE",
  TOOSOON = "TOOSOON",
  TPROD = "TPROD",
}

/**
 * All available FHIR Detected Issue Severity codes.
 */
export enum DetectedIssueSeverity {
  HIGH = "HIGH",
  LOW = "LOW",
  MODERATE = "MODERATE",
  UNKNOWN = "UNKNOWN",
}

/**
 * All available FHIR detected issue status codes.
 */
export enum DetectedIssueStatus {
  ENTERED_IN_ERROR = "ENTERED_IN_ERROR",
  FINAL = "FINAL",
  MITIGATED = "MITIGATED",
  PRELIMINARY = "PRELIMINARY",
}

/**
 * All possible FHIR Diagnosis type codes
 */
export enum DiagnosisType {
  ADMITTING = "ADMITTING",
  CLINICAL = "CLINICAL",
  DIFFERENTIAL = "DIFFERENTIAL",
  DISCHARGE = "DISCHARGE",
  LABORATORY = "LABORATORY",
  NURSING = "NURSING",
  PRENATAL = "PRENATAL",
  PRINCIPAL = "PRINCIPAL",
  RADIOLOGY = "RADIOLOGY",
  REMOTE = "REMOTE",
  RETROSPECTIVE = "RETROSPECTIVE",
  SELF = "SELF",
}

/**
 * All posisible FHIR discharge disposition codes.
 */
export enum DischargeDisposition {
  AADVICE = "AADVICE",
  ALT_HOME = "ALT_HOME",
  EXP = "EXP",
  HOME = "HOME",
  HOSP = "HOSP",
  LONG = "LONG",
  OTH = "OTH",
  OTHER_HCF = "OTHER_HCF",
  PSY = "PSY",
  REHAB = "REHAB",
  SNF = "SNF",
}

/**
 * All possible FHIR encounter admit source codes.
 */
export enum EncounterAdmitSource {
  BORN = "BORN",
  EMD = "EMD",
  GP = "GP",
  HOSP_TRANS = "HOSP_TRANS",
  MP = "MP",
  NURSING = "NURSING",
  OTHER = "OTHER",
  OUTP = "OUTP",
  PSYCH = "PSYCH",
  REHAB = "REHAB",
}

/**
 * All possible FHIR encounter class codes.
 */
export enum EncounterClass {
  AMB = "AMB",
  EMER = "EMER",
  HH = "HH",
  IMP = "IMP",
  OBSENC = "OBSENC",
  VR = "VR",
}

/**
 * All possible FHIR encounter diet codes.
 */
export enum EncounterDiet {
  DAIRY_FREE = "DAIRY_FREE",
  GLUTEN_FREE = "GLUTEN_FREE",
  HALAL = "HALAL",
  KOSHER = "KOSHER",
  NUT_FREE = "NUT_FREE",
  VEGAN = "VEGAN",
  VEGETARIAN = "VEGETARIAN",
}

/**
 * All possible FHIR encounter reason use codes.
 */
export enum EncounterReasonUse {
  AD = "AD",
  CC = "CC",
  HC = "HC",
  HM = "HM",
  RV = "RV",
}

/**
 * All possible FHIR encounter special arrangement codes
 */
export enum EncounterSpecialArrangements {
  ADD_BED = "ADD_BED",
  ATT = "ATT",
  DOG = "DOG",
  INT = "INT",
  WHEEL = "WHEEL",
}

/**
 * All possible FHIR encounter special courtesy codes.
 */
export enum EncounterSpecialCourtesy {
  EXT = "EXT",
  NRM = "NRM",
  PRF = "PRF",
  STF = "STF",
  VIP = "VIP",
}

/**
 * All possible encounter statuses
 */
export enum EncounterStatus {
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
  DISCHARGED = "DISCHARGED",
  DISCONTINUED = "DISCONTINUED",
  ENTERED_IN_ERROR = "ENTERED_IN_ERROR",
  IN_PROGRESS = "IN_PROGRESS",
  ON_HOLD = "ON_HOLD",
  PLANNED = "PLANNED",
  UNKNOWN = "UNKNOWN",
}

/**
 * All possible FHIR encounter subject status codes
 */
export enum EncounterSubjectStatus {
  ARRIVED = "ARRIVED",
  DEPARTED = "DEPARTED",
  ON_LEAVE = "ON_LEAVE",
  RECEIVING_CARE = "RECEIVING_CARE",
  TRIAGED = "TRIAGED",
}

/**
 * All possible FHIR event status codes.
 */
export enum EventStatuses {
  COMPLETED = "COMPLETED",
  ENTERED_IN_ERROR = "ENTERED_IN_ERROR",
  INCOMPLETE = "INCOMPLETE",
  IN_PROGRESS = "IN_PROGRESS",
  NOT_DONE = "NOT_DONE",
  ON_HOLD = "ON_HOLD",
  PREPARATION = "PREPARATION",
  STOPPED = "STOPPED",
  UNKNOWN = "UNKNOWN",
}

/**
 * Defines the possible type of grouped form inputs.
 */
export enum FormInputGroupType {
  CHECKBOX = "CHECKBOX",
  CREATABLE_SELECT = "CREATABLE_SELECT",
  DATE = "DATE",
  DATETIME = "DATETIME",
  MULTI_SELECT = "MULTI_SELECT",
  RADIO = "RADIO",
  RADIO_RANGE = "RADIO_RANGE",
  RANGE = "RANGE",
  SELECT = "SELECT",
  SWITCH = "SWITCH",
  TEXT = "TEXT",
  TEXTAREA = "TEXTAREA",
}

export enum GeocodingStatusCodes {
  ERROR = "ERROR",
  INVALID_REQUEST = "INVALID_REQUEST",
  OK = "OK",
  OVER_QUERY_LIMIT = "OVER_QUERY_LIMIT",
  REQUEST_DENIED = "REQUEST_DENIED",
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
  ZERO_RESULTS = "ZERO_RESULTS",
}

/**
 * All possible FHIR Goal Achievement status codes.
 */
export enum GoalAchievementStatus {
  ACHIEVED = "ACHIEVED",
  IMPROVING = "IMPROVING",
  IN_PROGRESS = "IN_PROGRESS",
  NOT_ACHIEVED = "NOT_ACHIEVED",
  NOT_ATTAINABLE = "NOT_ATTAINABLE",
  NO_CHANGE = "NO_CHANGE",
  NO_PROGRESS = "NO_PROGRESS",
  SUSTAINING = "SUSTAINING",
  WORSENING = "WORSENING",
}

/**
 * All possible FHIR Goal category codes.
 */
export enum GoalCategory {
  BEHAVIORAL = "BEHAVIORAL",
  DIETARY = "DIETARY",
  NURSING = "NURSING",
  PHYSIOTHERAPY = "PHYSIOTHERAPY",
  SAFETY = "SAFETY",
}

/**
 * All possible FHIR Goal priority codes
 */
export enum GoalPriority {
  HIGH_PRIORITY = "HIGH_PRIORITY",
  LOW_PRIORITY = "LOW_PRIORITY",
  MEDIUM_PRIORITY = "MEDIUM_PRIORITY",
}

/**
 * All possible FHIR Group membership basis codes.
 */
export enum GroupMembershipBasis {
  DEFINITIONAL = "DEFINITIONAL",
  ENUMERATED = "ENUMERATED",
}

/**
 * All possible FHIR identifier type codes.
 */
export enum IdentifierType {
  ACSN = "ACSN",
  BRN = "BRN",
  DL = "DL",
  DR = "DR",
  EN = "EN",
  FILL = "FILL",
  JHN = "JHN",
  MCN = "MCN",
  MD = "MD",
  MR = "MR",
  NIIP = "NIIP",
  PLAC = "PLAC",
  PPN = "PPN",
  PRN = "PRN",
  SB = "SB",
  SNO = "SNO",
  TAX = "TAX",
  UDI = "UDI",
}

/**
 * All possible FHIR resource identifier use codes.
 */
export enum IdentifierUse {
  OFFICIAL = "OFFICIAL",
  OLD = "OLD",
  SECONDARY = "SECONDARY",
  TEMP = "TEMP",
  USUAL = "USUAL",
}

/**
 * All possible FHIR Clinical impression change-pattern codes
 */
export enum ImpressionChangePatternCodes {
  IMPROVING = "IMPROVING",
  NO_CHANGE = "NO_CHANGE",
  UNKNOWN = "UNKNOWN",
  WORSENING = "WORSENING",
}

/**
 * All possible FHIR medication codes.
 */
export enum MedicationCodes {
  HYPOTENSIVE_AGENT = "HYPOTENSIVE_AGENT",
  MEDICINAL_PRODUCT = "MEDICINAL_PRODUCT",
  THERAPEUTIC_RADIOISOTOPE = "THERAPEUTIC_RADIOISOTOPE",
}

/**
 * All possible medication request administration location codes.
 */
export enum MedicationRequestAdministrativeLocation {
  COMMUNITY = "COMMUNITY",
  INPATIENT = "INPATIENT",
  OUTPATIENT = "OUTPATIENT",
}

/**
 * All possible FHIR medication usage adherence codes.
 */
export enum MedicationUsageAdherence {
  NOT_TAKING = "NOT_TAKING",
  TAKING = "TAKING",
  TAKING_AS_DIRECTED = "TAKING_AS_DIRECTED",
  TAKING_NOT_AS_DIRECTED = "TAKING_NOT_AS_DIRECTED",
  UNKNOWN = "UNKNOWN",
}

/**
 * All possible medication usage FHIR status codes.
 */
export enum MedicationUsageStatus {
  DRAFT = "DRAFT",
  ENTERED_IN_ERROR = "ENTERED_IN_ERROR",
  RECORDED = "RECORDED",
}

/**
 * All possible medication FHIR status codes
 */
export enum MedicationsStatus {
  ACTIVE = "ACTIVE",
  ENTERED_IN_ERROR = "ENTERED_IN_ERROR",
  INACTIVE = "INACTIVE",
}

/**
 * List of folders for messages
 */
export enum MessageFolders {
  Inbox = "Inbox",
  Starred = "Starred",
  Trash = "Trash",
}

/**
 * Labels or 'tags' to associate messages to
 */
export enum MessageLabels {
  Default = "Default",
  Important = "Important",
  Personal = "Personal",
  Private = "Private",
  Report = "Report",
}

/**
 * Enumerable values representing notification priority.
 */
export enum NotificationPriority {
  High = "High",
  Low = "Low",
  Max = "Max",
  Normal = "Normal",
}

/**
 * Status codes for application orders
 */
export enum OrderStatus {
  ARCHIVED = "ARCHIVED",
  CANCELLED = "CANCELLED",
  COMPLETE = "COMPLETE",
  IN_PROGRESS = "IN_PROGRESS",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
}

/**
 * The health and safety precautions and organization has in place
 */
export enum OrganizationHealthAndSafetyPrecautions {
  AppointmentRequired = "AppointmentRequired",
  DisinfectSurfaces = "DisinfectSurfaces",
  MasksRequired = "MasksRequired",
  StaffMasks = "StaffMasks",
  StaffTemperatureChecks = "StaffTemperatureChecks",
  TemperatureChecks = "TemperatureChecks",
}

/**
 * All available organization roles
 */
export enum OrganizationRoles {
  AGENCY = "AGENCY",
  DIAGNOSTICS = "DIAGNOSTICS",
  ENTITY = "ENTITY",
  HIE_HIO = "HIE_HIO",
  MEMBER = "MEMBER",
  PAYER = "PAYER",
  PROVIDER = "PROVIDER",
  RESEARCH = "RESEARCH",
  SUPPLIER = "SUPPLIER",
}

/**
 * All available organization types
 */
export enum OrganizationTypes {
  CLINICAL_RESEARCH_SPONSOR = "CLINICAL_RESEARCH_SPONSOR",
  COMMUNITY_GROUP = "COMMUNITY_GROUP",
  EDUCATIONAL_INSTITUTE = "EDUCATIONAL_INSTITUTE",
  GOVERNMENT = "GOVERNMENT",
  HEALTHCARE_PROVIDER = "HEALTHCARE_PROVIDER",
  HOSPITAL_DEPARTMENT = "HOSPITAL_DEPARTMENT",
  INSURANCE_COMPANY = "INSURANCE_COMPANY",
  NON_HEALTHCARE_BUSINESS = "NON_HEALTHCARE_BUSINESS",
  ORGANIZATIONAL_TEAM = "ORGANIZATIONAL_TEAM",
  OTHER = "OTHER",
  PAYER = "PAYER",
  RELIGIOUS_INSTITUTION = "RELIGIOUS_INSTITUTION",
}

/**
 * Application master list of all panels offered
 */
export enum PanelList {
  CBCPanel = "CBCPanel",
  LipidPanel = "LipidPanel",
  MetabolicPanel = "MetabolicPanel",
  ToxicologyPanel = "ToxicologyPanel",
}

/**
 * All available FHIR participant role codes.
 */
export enum ParticipantRole {
  CAREGIVER = "CAREGIVER",
  HEALTHCARE_PROFESSIONAL = "HEALTHCARE_PROFESSIONAL",
  NURSE = "NURSE",
  PATIENT = "PATIENT",
  PHARMACIST = "PHARMACIST",
  PHYSICIAN = "PHYSICIAN",
}

/**
 * This FHIR value set is comprised of Actor participation Type codes, which can be used to value FHIR agents, actors, and other role elements. The codes are intended to express how the agent participated in some activity. Sometimes referred to the agent functional-role relative to the activity.
 */
export enum ParticipantRoleType {
  ASSEMBLER = "ASSEMBLER",
  ATTESTER = "ATTESTER",
  AUTHOR = "AUTHOR",
  AUTHSERVER = "AUTHSERVER",
  COMPOSER = "COMPOSER",
  CUSTODIAN = "CUSTODIAN",
  DATACOLLECTOR = "DATACOLLECTOR",
  DATAPROCESSOR = "DATAPROCESSOR",
  DATASUBJECT = "DATASUBJECT",
  ENTERER = "ENTERER",
  HUMANUSER = "HUMANUSER",
  INFORMANT = "INFORMANT",
  LEGAL = "LEGAL",
  PERFORMER = "PERFORMER",
  VERIFIER = "VERIFIER",
}

/**
 * All possible FHIR participant type codes.
 */
export enum ParticipantType {
  ADM = "ADM",
  ATND = "ATND",
  CALLBCK = "CALLBCK",
  CON = "CON",
  DIS = "DIS",
  EMERGENCY = "EMERGENCY",
  ESC = "ESC",
  REF = "REF",
  TRANSLATOR = "TRANSLATOR",
}

/**
 * all available organization contact type codes
 */
export enum PatientContactCodes {
  Care_Contact = "Care_Contact",
  Emergency_Contact = "Emergency_Contact",
  Employer = "Employer",
  Federal_Agency = "Federal_Agency",
  Insurance_Company = "Insurance_Company",
  Next_of_Kin = "Next_of_Kin",
  State_Agency = "State_Agency",
  Unknown = "Unknown",
}

/**
 * All possible FHIR Publication status codes
 */
export enum PublicationStatus {
  ACTIVE = "ACTIVE",
  DRAFT = "DRAFT",
  RETIRED = "RETIRED",
  UNKNOWN = "UNKNOWN",
}

/**
 * All possible FHIR quantity comparator operator codes.
 */
export enum QuantityComparator {
  EQUALS = "EQUALS",
  GREATER_OR_EQUAL = "GREATER_OR_EQUAL",
  GREATER_THAN = "GREATER_THAN",
  LESS_OR_EQUAL = "LESS_OR_EQUAL",
  LESS_THAN = "LESS_THAN",
  NOT_EQUALS = "NOT_EQUALS",
  SUFFICIENT = "SUFFICIENT",
}

/**
 * All possible FHIR Questionnaire answer constraint codes
 */
export enum QuestionnaireAnswerConstraint {
  OPTIONS_ONLY = "OPTIONS_ONLY",
  OPTIONS_OR_STRING = "OPTIONS_OR_STRING",
  OPTIONS_OR_TYPE = "OPTIONS_OR_TYPE",
}

/**
 * All possible FHIR Questionnaire answer status codes.
 */
export enum QuestionnaireAnswerStatus {
  AMENDED = "AMENDED",
  COMPLETED = "COMPLETED",
  ENTERED_IN_ERROR = "ENTERED_IN_ERROR",
  INCOMPLETE = "INCOMPLETE",
  IN_PROGRESS = "IN_PROGRESS",
  STOPPED = "STOPPED",
}

/**
 * All possible FHIR Questionnaire disabled display codes.
 */
export enum QuestionnaireDisabledDisplay {
  HIDDEN = "HIDDEN",
  PROTECTED = "PROTECTED",
}

/**
 * All possible FHIR Questionnaire enable behavior codes
 */
export enum QuestionnaireEnableBehavior {
  ALL = "ALL",
  ANY = "ANY",
}

/**
 * All possible FHIR Questionnaire enable operators
 */
export enum QuestionnaireEnableOperator {
  EQUALS = "EQUALS",
  EXISTS = "EXISTS",
  GREATER_OR_EQUALS = "GREATER_OR_EQUALS",
  GREATER_THAN = "GREATER_THAN",
  LESS_OR_EQUALS = "LESS_OR_EQUALS",
  LESS_THAN = "LESS_THAN",
  NOT_EQUALS = "NOT_EQUALS",
}

/**
 * All possible FHIR Questionnaire item type codes.
 */
export enum QuestionnaireItemType {
  ATTACHMENT = "ATTACHMENT",
  BOOLEAN = "BOOLEAN",
  CODING = "CODING",
  DATE = "DATE",
  DATE_TIME = "DATE_TIME",
  DECIMAL = "DECIMAL",
  DISPLAY = "DISPLAY",
  GROUP = "GROUP",
  INTEGER = "INTEGER",
  QUANTITY = "QUANTITY",
  QUESTION = "QUESTION",
  RADIO_GROUP = "RADIO_GROUP",
  REFERENCE = "REFERENCE",
  STRING = "STRING",
  TEXT = "TEXT",
  TIME = "TIME",
  URL = "URL",
}

/**
 * Logic processing identifiers. Use when questionnaire responses need additional processing logic
 */
export enum QuestionnaireLogicHandler {
  MCGEER_UTI = "MCGEER_UTI",
}

/**
 * All applicable related person types
 */
export enum RelatedPersonTypes {
  Adopted_Child = "Adopted_Child",
  Adopted_Daughter = "Adopted_Daughter",
  Adopted_Son = "Adopted_Son",
  Aunt = "Aunt",
  Brother = "Brother",
  Brother_In_Law = "Brother_In_Law",
  Child = "Child",
  Child_In_law = "Child_In_law",
  Cousin = "Cousin",
  Daughter = "Daughter",
  Daughter_In_Law = "Daughter_In_Law",
  Extended_Family_Member = "Extended_Family_Member",
  Family_Member = "Family_Member",
  Father = "Father",
  Father_In_Law = "Father_In_Law",
  Fiance = "Fiance",
  Foster_Child = "Foster_Child",
  Foster_Daughter = "Foster_Daughter",
  Foster_Son = "Foster_Son",
  Grandchild = "Grandchild",
  Granddaughter = "Granddaughter",
  Grandfather = "Grandfather",
  Grandmother = "Grandmother",
  Grandparent = "Grandparent",
  Grandson = "Grandson",
  Great_Grandfather = "Great_Grandfather",
  Great_Grandmother = "Great_Grandmother",
  Great_Grandparent = "Great_Grandparent",
  Husband = "Husband",
  In_Law = "In_Law",
  Mother = "Mother",
  Mother_In_Law = "Mother_In_Law",
  Neighbor = "Neighbor",
  Nephew = "Nephew",
  Niece = "Niece",
  Parent = "Parent",
  Parent_In_Law = "Parent_In_Law",
  Roommate = "Roommate",
  Self = "Self",
  Sibling = "Sibling",
  Sibling_In_Law = "Sibling_In_Law",
  Sister = "Sister",
  Sister_In_Law = "Sister_In_Law",
  Son = "Son",
  Son_In_Law = "Son_In_Law",
  Spouse = "Spouse",
  Step_Child = "Step_Child",
  Step_Parent = "Step_Parent",
  Stepbrother = "Stepbrother",
  Stepdaughter = "Stepdaughter",
  Stepfather = "Stepfather",
  Stepmother = "Stepmother",
  Stepsister = "Stepsister",
  Stepson = "Stepson",
  Uncle = "Uncle",
  Unrelated_Friend = "Unrelated_Friend",
  Wife = "Wife",
}

/**
 * All possible healthcare service categories
 */
export enum ServiceCategories {
  COVID19 = "COVID19",
  DigestiveHealth = "DigestiveHealth",
  DrugAndAlcohol = "DrugAndAlcohol",
  GeneralHealth = "GeneralHealth",
  HeartHealth = "HeartHealth",
  InfectiousDisease = "InfectiousDisease",
  MensHealth = "MensHealth",
  STD = "STD",
  WomensHealth = "WomensHealth",
}

/**
 * All possible service intent status codes
 */
export enum ServiceIntentStatus {
  CANCELLED = "CANCELLED",
  DIRECTIVE = "DIRECTIVE",
  FILLED_ORDER = "FILLED_ORDER",
  INSTANCE_ORDER = "INSTANCE_ORDER",
  ORDER = "ORDER",
  ORIGINAL_ORDER = "ORIGINAL_ORDER",
  PENDING = "PENDING",
  PLAN = "PLAN",
  REFLEX_ORDER = "REFLEX_ORDER",
}

/**
 * All possible service request priorities
 */
export enum ServiceRequestPriority {
  ASAP = "ASAP",
  LOW = "LOW",
  ROUTINE = "ROUTINE",
  STAT = "STAT",
  URGENT = "URGENT",
}

/**
 * All possible service request statuses
 */
export enum ServiceRequestStatus {
  ACTIVE = "ACTIVE",
  CANCELLED = "CANCELLED",
  COLLECTED = "COLLECTED",
  COMPLETED = "COMPLETED",
  DRAFT = "DRAFT",
  ENTERED_IN_ERROR = "ENTERED_IN_ERROR",
  IN_PROGRESS = "IN_PROGRESS",
  ON_HOLD = "ON_HOLD",
  REVOKE = "REVOKE",
  UNKNOWN = "UNKNOWN",
}

/**
 * List of all patient symptom codes.
 */
export enum SymptomCodes {
  ABDOMINAL_PAIN = "ABDOMINAL_PAIN",
  BLOOD_CLOTS = "BLOOD_CLOTS",
  CHEST_PAIN = "CHEST_PAIN",
  CHILLS = "CHILLS",
  COUGHING = "COUGHING",
  EAR_PAIN = "EAR_PAIN",
  FEVER = "FEVER",
  LIGHT_HEADED = "LIGHT_HEADED",
  MIGRAINE = "MIGRAINE",
  RASH = "RASH",
  REDNESS = "REDNESS",
  SWELLING = "SWELLING",
  THROAT_PAIN = "THROAT_PAIN",
  VERTIGO = "VERTIGO",
}

/**
 * All possible FHIR task codes.
 */
export enum TaskCode {
  ABORT = "ABORT",
  APPROVE = "APPROVE",
  CHANGE = "CHANGE",
  FULFILL = "FULFILL",
  INSTANTIATE = "INSTANTIATE",
  REPLACE = "REPLACE",
  RESUME = "RESUME",
  SUSPEND = "SUSPEND",
}

/**
 * All possible FHIR task intent codes.
 */
export enum TaskIntent {
  FILLER_ORDER = "FILLER_ORDER",
  INSTANCE_ORDER = "INSTANCE_ORDER",
  ORDER = "ORDER",
  ORDER_OPTION = "ORDER_OPTION",
  ORIGINAL_ORDER = "ORIGINAL_ORDER",
  PLAN = "PLAN",
  PROPOSAL = "PROPOSAL",
  REFLEX_ORDER = "REFLEX_ORDER",
  UNKNOWN = "UNKNOWN",
}

/**
 * Categorization labels for user tasks.
 */
export enum TaskLabels {
  ACTIVE = "ACTIVE",
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
  DEFAULT = "DEFAULT",
  DELETED = "DELETED",
  DRAFT = "DRAFT",
  IMPORTANT = "IMPORTANT",
  IN_PROGRESS = "IN_PROGRESS",
  NEW = "NEW",
}

/**
 * All possible FHIR task status codes.
 */
export enum TaskStatus {
  ACCEPTED = "ACCEPTED",
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
  DRAFT = "DRAFT",
  ENTERED_IN_ERROR = "ENTERED_IN_ERROR",
  FAILED = "FAILED",
  IN_PROGRESS = "IN_PROGRESS",
  ON_HOLD = "ON_HOLD",
  READY = "READY",
  RECEIVED = "RECEIVED",
  REJECTED = "REJECTED",
  REQUESTED = "REQUESTED",
}

/**
 * All possible FHIR task status reason codes.
 */
export enum TaskStatusReason {
  ENVIRONMENTAL_ISSUE = "ENVIRONMENTAL_ISSUE",
  EQUIPMENT_ISSUE = "EQUIPMENT_ISSUE",
  MISIDENTIFIED = "MISIDENTIFIED",
  MISSING = "MISSING",
  NA = "NA",
  PERSONNEL_ISSUE = "PERSONNEL_ISSUE",
  UNKNOWN = "UNKNOWN",
}

/**
 * All possible FHIR timing abbreviation codes.
 */
export enum TimingAbbreviations {
  AM = "AM",
  BED = "BED",
  BID = "BID",
  MO = "MO",
  PM = "PM",
  Q1H = "Q1H",
  Q2H = "Q2H",
  Q3H = "Q3H",
  Q4H = "Q4H",
  Q6H = "Q6H",
  Q8H = "Q8H",
  QD = "QD",
  QID = "QID",
  QOD = "QOD",
  TID = "TID",
  WK = "WK",
}

/**
 * All possible methods of 2FA
 */
export enum TwoFactorMethods {
  PUSH = "PUSH",
  SMS = "SMS",
  TOTP = "TOTP",
}

/**
 * Application User Types
 */
export enum UserTypes {
  admin = "admin",
  organization = "organization",
  patient = "patient",
  staff = "staff",
  practitioner = "practitioner"
}

export interface AddPatientMedicationInput {
  patientId: string;
  medicationID?: string | null;
  brandName: string;
  medicationCode: MedicationCodes;
  prescriber: string;
  effectivePeriod: PeriodCreateInput;
  dosage: MedicationDosageInput;
  method: string;
  dosageInstruction: string;
  icd10Codes: string[];
  notes?: string | null;
}

export interface AppointmentInput {
  collectionDayTimeBlockID: string[];
  email: string;
  dependentID?: string | null;
  relationContactID?: string | null;
}

export interface AppointmentRescheduleInput {
  appointmentID: string;
  newTimeBlockID: string;
}

export interface BaseAnswerOptionsInput {
  options: QuestionnaireAnswerOptionsInput[];
  answerConstraint: QuestionnaireAnswerConstraint;
}

export interface BaseEnableWhenInput {
  operator: QuestionnaireEnableOperator;
  enableBehavior: QuestionnaireEnableBehavior;
  answer: QuestionnaireEnableWhenAnswers;
  linkId?: string | null;
  disabledDisplay?: QuestionnaireDisabledDisplay | null;
}

export interface BasicSearch {
  stringValues?: string[] | null;
  numberValues?: number[] | null;
  booleanValue?: boolean | null;
  columnName: string;
}

export interface BillingAddressDetailsType {
  addressLine1: string;
  formattedAddress?: string | null;
  city: string;
  state: string;
  zip: string;
}

export interface BillingAddressType {
  firstName: string;
  lastName: string;
  address: BillingAddressDetailsType;
}

export interface BillingDetailsType {
  paymentInformation: PaymentDetailsType;
  shippingAddress?: BillingAddressType | null;
  orderItems: BillingOrderItemsType[];
  totalAmount: string;
  shippingSameAsBilling: boolean;
  savePaymentToProfile: boolean;
}

export interface BillingOrderItemsType {
  serviceID: string;
  name: string;
  description: string;
  quantity: number;
  price: number;
}

export interface CarePlanCreateInput {
  title: string;
  description: string;
  category: string;
  status: ServiceRequestStatus;
  intent?: ServiceIntentStatus | null;
  serviceRequestId?: string | null;
  diagnosisCode?: string | null;
  replacedCarePlanId?: string | null;
  parentCarePlanId?: string | null;
  encounterId?: string | null;
  period?: PeriodCreateInput | null;
  note?: string | null;
  subject: CarePlanSubjectInput;
}

export interface CarePlanSubjectInput {
  patientId?: string | null;
  groupId?: string | null;
}

export interface CareTeamMemberCreateInput {
  role: ParticipantRole;
  timingId?: string | null;
  organizationId?: string | null;
  memberName: string;
  assignmentId: string;
}

export interface ClinicalNoteCreateInput {
  subject: string;
  text: string;
  patientId: string;
  authoredAt?: any | null;
  encounterID?: string | null;
}

export interface ConditionAbatementInput {
  abatementDateTime?: any | null;
  abatementDateString?: string | null;
}


export interface ConditionInput {
  clinicalStatus: ConditionClinicalStatus;
  icd10Code: string;
  typeOfParticipantInvolvement: ParticipantRoleType;
  bodySite?: string | null;
  conditionCode?: ConditionCodes | null;
  category?: ConditionCategoryCodes | null;
  recordedDate?: any | null;
  severity?: ConditionSeverityCodes | null;
  note?: string | null;
  medicationUsageID?: string | null;
  encounterID?: string | null;
  carePlanID?: string | null;
  onset?: ConditionOnsetInput | null;
  abatement?: ConditionAbatementInput | null;
  verificationStatus?: ConditionVerificationStatus | null;
}

export interface ConditionOnsetInput {
  onsetDateTime?: any | null;
  onsetDateString?: string | null;
}

export interface ConditionUpdateInput {
  conditionID: string;
  clinicalStatus?: ConditionClinicalStatus | null;
  category?: ConditionCategoryCodes | null;
  conditionCode?: ConditionCodes | null;
  medicationUsageID?: string | null;
  symptom?: SymptomCodes | null;
  typeOfParticipantInvolvement?: ParticipantRoleType | null;
  severity?: ConditionSeverityCodes | null;
  note?: string | null;
  encounterID?: string | null;
  carePlanID?: string | null;
  onset?: ConditionOnsetInput | null;
  abatement?: ConditionAbatementInput | null;
  verificationStatus?: ConditionVerificationStatus | null;
}

export interface Coordinates {
  lat?: number | null;
  lng?: number | null;
}

export interface CreditCardDetailsType {
  cardNumber: string;
  expirationDate: string;
  cvv: string;
}

export interface CustomerPaymentInformationType {
  cardDetails: CreditCardDetailsType;
  billingAddress: BillingAddressType;
}

export interface CustomerPaymentProfileType {
  customerPaymentProfileID: string;
  customerProfileID: string;
}

export interface GoalTargetInput {
  targetQuantity?: QuantityCreateInput | null;
  targetRange?: RangeCreateInput | null;
  targetRatio?: RatioCreateInput | null;
  targetString?: string | null;
  targetBoolean?: boolean | null;
  targetInteger?: number | null;
}

export interface GridLayoutPropertiesInput {
  xs?: number | null;
  sm?: number | null;
  md?: number | null;
  lg?: number | null;
  xl?: number | null;
  xxl?: number | null;
}

export interface IdentifierCreateInput {
  use: IdentifierUse;
  type: IdentifierType;
  value: string;
  validPeriod?: PeriodCreateInput | null;
  organizationId?: string | null;
}

export interface KeywordSearch {
  columnName: string;
  keyword: string;
  fullTextSearch?: boolean | null;
  exactMatch?: boolean | null;
}

export interface LayoutConfigurationInput {
  column: GridLayoutPropertiesInput;
}

export interface LoginRequest {
  appId: string;
  email: string;
  password: string;
  userType: UserTypes;
}

export interface MedicationDosageInput {
  strength: MedicationStrengthInput;
  frequency: MedicationFrequencyInput;
  timing: TimingAbbreviations;
}

export interface MedicationDosageUpdateInput {
  strength: MedicationStrengthInput;
  frequency: MedicationFrequencyInput;
}

export interface MedicationFrequencyInput {
  form: string;
  quantity: number;
}

export interface MedicationStrengthInput {
  value: number;
  unit: string;
}

export interface MedicationUpdateInput {
  medicationID: string;
  brandName?: string | null;
  medicationCode?: MedicationCodes | null;
  status?: MedicationsStatus | null;
  form?: string | null;
  manufacturer?: string | null;
  organizationId?: string | null;
  dosage?: MedicationDosageUpdateInput | null;
}

export interface MedicationUsageUpdateInput {
  usageID: string;
  prescriberId?: string | null;
  status?: MedicationUsageStatus | null;
  category?: MedicationRequestAdministrativeLocation | null;
  effectiveDate?: any | null;
  dateAsserted?: any | null;
  dosageInstruction?: string | null;
  allFeedbackRequestsSent?: boolean | null;
  notificationID?: string | null;
  feedbackRequested?: boolean | null;
  notes?: string | null;
  adherence?: MedicationUsageAdherence | null;
  effectivePeriod?: PeriodCreateInput | null;
  timing?: TimingAbbreviations | null;
  method?: string | null;
  conditionIDs?: string[] | null
}

export interface MessageUpdatePayload {
  labels?: MessageLabels[] | null;
  is_trashed?: boolean | null;
  is_starred?: boolean | null;
  is_read?: boolean | null;
  folder?: MessageFolders | null;
  attachment?: string | null;
}

export interface NotificationUpdatePayload {
  is_read?: boolean | null;
}

export interface OperatorSearch {
  operator: string;
  value: string;
  columnName: string;
}

export interface OrderByArgs {
  column: string;
  direction: string;
}

export interface PaginationArgs {
  limit?: number | null;
  offset?: number | null;
  page?: number | null;
  size?: number | null;
}

export interface PatientMedicationUpdateInput {
  medication?: MedicationUpdateInput | null;
  usage?: MedicationUsageUpdateInput | null;
}

export interface PaymentDetailsType {
  cardPayment?: CustomerPaymentInformationType | null;
  paymentProfile?: CustomerPaymentProfileType | null;
}

export interface PeriodCreateInput {
  start: any;
  end: any;
}

export interface QuantityCreateInput {
  value: number;
  unit: string;
  comparator?: QuantityComparator | null;
  code?: string | null;
  system?: string | null;
}

export interface QueryOptionsInputType {
  limit?: number | null;
  subQuery?: boolean | null;
  paranoid?: boolean | null;
}

export interface QuestionnaireAnswerCreateInput {
  questionItemID: string;
  answer: QuestionnaireProvidedAnswerOptions;
}

export interface QuestionnaireAnswerOptionsInput {
  isInitiallySelected?: boolean | null;
  label?: string | null;
  icon?: string | null;
  order?: number | null;
  integerOption?: number | null;
  dateOption?: any | null;
  timeOption?: string | null;
  stringOption?: string | null;
  codingOption?: string | null;
  booleanOption?: boolean | null;
  multiOption?: boolean | null;
  rangeOption?: RangeCreateInput | null;
}

export interface QuestionnaireAnswerUpdateInput {
  answerID: string;
  answer: QuestionnaireProvidedAnswerOptions;
}

export interface QuestionnaireEnableWhenAnswers {
  quantity?: QuantityCreateInput | null;
  booleanAnswer?: boolean | null;
  decimalAnswer?: number | null;
  integerAnswer?: number | null;
  dateAnswer?: any | null;
  timeAnswer?: string | null;
  stringAnswer?: string | null;
  codingAnswer?: string | null;
}

export interface QuestionnaireFormCreateInput {
  title: string;
  linkID: string;
  status: PublicationStatus;
  description: string;
  purpose: string;
  protocol?: QuestionnaireLogicHandler | null;
  activePeriod?: PeriodCreateInput | null;
  experimental?: boolean | null;
  subjectType?: string | null;
  questionnaireUrl?: string | null;
}

export interface QuestionnaireProvidedAnswerOptions {
  quantity?: QuantityCreateInput | null;
  booleanAnswer?: boolean | null;
  decimalAnswer?: number | null;
  integerAnswer?: number | null;
  dateAnswer?: any | null;
  timeAnswer?: string | null;
  stringAnswer?: string | null;
  codingAnswer?: string | null;
  uriAnswer?: string | null;
  attachmentAnswer?: string | null;
  rangeAnswer?: RangeCreateInput | null;
  selectAnswer?: string | null;
}

export interface QuestionnaireQuestionCreateInput {
  questionnaireNumber: number;
  questions: QuestionnaireQuestionInput[];
}

export interface QuestionnaireQuestionInput {
  questionText: string;
  questionType: QuestionnaireItemType;
  inputType: FormInputGroupType;
  isRequired: boolean;
  isReadOnly: boolean;
  linkId: string;
  responseLabel?: string | null;
  layoutConfig?: LayoutConfigurationInput | null;
  order?: number | null;
  isRepeating?: boolean | null;
  maxAnswerLength?: number | null;
  questionPrefix?: string | null;
  answerOptions?: BaseAnswerOptionsInput | null;
  enableWhen?: BaseEnableWhenInput | null;
}

export interface QuestionnaireResponseCreateInput {
  questionnaireNumber: number;
  patientId: string;
  status: QuestionnaireAnswerStatus;
  answers: QuestionnaireAnswerCreateInput[];
  carePlanID?: string | null;
  taskID?: string | null;
  completedAt?: any | null;
}

export interface QuestionnaireResponseUpdateInput {
  responseID: string;
  status?: QuestionnaireAnswerStatus | null;
  completedAt?: any | null;
  answers?: QuestionnaireAnswerUpdateInput[] | null;
}

export interface RangeCreateInput {
  low: QuantityCreateInput;
  high: QuantityCreateInput;
}

export interface RangeSearch {
  numRange?: number[] | null;
  dateRange?: string[] | null;
  columnName: string;
}

export interface RatioCreateInput {
  numerator: QuantityCreateInput;
  denominator: QuantityCreateInput;
}

export interface RecordSearch {
  stringValues?: string[] | null;
  numberValues?: number[] | null;
  booleanValue?: boolean | null;
  columnName: string;
}

export interface ReferenceCreateInput {
  type: string;
  display: string;
  identifier: IdentifierCreateInput;
  reference?: string | null;
}

export interface RegisterRequest {
  appId: string;
  userType: string;
  email: string;
  password: string;
  username?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  dob: any;
  phone?: string | null;
  address?: UserAddressDataInput | null;
  permissionId?: string | null;
  organizationId?: string | null;
  orgTypeID?: number | null;
  orgRoleID?: number | null;
  name?: string | null;
  alias?: string | null;
  npiNumber?: string | null;
  cliaNumber?: string | null;
  colaNumber?: string | null;
  firstLogin?: boolean | null;
  validated?: boolean | null;
}

export interface SearchByArgs {
  querySet?: RecordSearch[] | null;
  basicQuery?: BasicSearch | null;
  queryRange?: RangeSearch | null;
  queryOperator?: OperatorSearch[] | null;
  queryKeyword?: KeywordSearch[] | null;
}

export interface SortingArgs {
  order: OrderByArgs;
}

export interface StepInformationValuesInput {
  valueBoolean?: boolean | null;
  valueDate?: any | null;
  valueDateTime?: any | null;
  valueDecimal?: number | null;
  valueMarkdown?: string | null;
  valueUuid?: string | null;
  valueInteger?: number | null;
  valueString?: string | null;
  valueArray?: string[] | null;
  valueUrl?: string | null;
  quantity?: QuantityCreateInput | null;
  range?: RangeCreateInput | null;
  ratio?: RatioCreateInput | null;
  period?: PeriodCreateInput | null;
  identifier?: IdentifierCreateInput | null;
  reference: ReferenceCreateInput;
}

export interface StepOutputUpdateInput {
  taskOutputId: string;
  value: StepInformationValuesInput;
  label?: string | null;
}

export interface SwitchPayloadInput {
  assignment_id: string;
}

export interface SymptomsCreateInput {
  icd10Codes: string[];
  carePlanId?: string | null;
}

export interface TaskActorInput {
  organizationId?: string | null;
  staffRelationId?: string | null;
  patientId?: string | null;
}

export interface TaskCreateInput {
  statusReason?: TaskStatusReason | null;
  notificationId?: string | null;
  label?: TaskLabels | null;
  url?: string | null;
  link?: string | null;
  startedAt?: any | null;
  completedAt?: any | null;
  doNotPerform?: boolean | null;
  encounterId?: string | null;
  activityDefinitionId?: string | null;
  parentTaskId?: string | null;
  annotation?: string | null;
  title: string;
  description: string;
  status: TaskStatus;
  businessStatus: string;
  intent: TaskIntent;
  priority: ServiceRequestPriority;
  code: TaskCode;
  assigneeRole: string;
  assigneeFunction: ActionParticipantFunction;
  reason: string;
  locationId: string;
  patientId: string;
  reference: ReferenceCreateInput;
  requestedPeriod: PeriodCreateInput;
  assignee: TaskActorInput;
}

export interface TaskStepUpdateInput {
  progress?: number | null;
  required?: boolean | null;
  statusReason?: TaskStatusReason | null;
  link?: string | null;
  url?: string | null;
  startedAt?: any | null;
  annotation?: string | null;
  label?: string | null;
  description?: string | null;
  order?: number | null;
  status?: TaskStatus | null;
  stepId?: string | null;
  focusReferenceId?: string | null;
  output?: StepOutputUpdateInput[] | null;
}

export interface TaskUpdateInput {
  statusReason?: TaskStatusReason | null;
  notificationId?: string | null;
  label?: TaskLabels | null;
  url?: string | null;
  link?: string | null;
  startedAt?: any | null;
  completedAt?: any | null;
  doNotPerform?: boolean | null;
  encounterId?: string | null;
  activityDefinitionId?: string | null;
  parentTaskId?: string | null;
  annotation?: string | null;
  taskId: string;
  title?: string | null;
  description?: string | null;
  status?: TaskStatus | null;
  businessStatus?: string | null;
  intent?: TaskIntent | null;
  priority?: ServiceRequestPriority | null;
  code?: TaskCode | null;
  reason?: string | null;
  requestedPeriod?: PeriodCreateInput | null;
  assignee?: TaskActorInput | null;
}

/**
 * Populate either "conditionId" for existing condition, or "condition" to create new condition
 */
export interface TreatmentConditionsCreateInput {
  conditionId?: string | null;
  condition?: TreatmentConditionsInput | null;
}

export interface TreatmentConditionsInput {
  clinicalStatus: ConditionClinicalStatus;
  icd10Code: string;
  typeOfParticipantInvolvement: ParticipantRoleType;
  bodySite?: string | null;
  conditionCode?: ConditionCodes | null;
  category?: ConditionCategoryCodes | null;
  recordedDate?: any | null;
  severity?: ConditionSeverityCodes | null;
  note?: string | null;
  onset?: ConditionOnsetInput | null;
  abatement?: ConditionAbatementInput | null;
  verificationStatus?: ConditionVerificationStatus | null;
}

export interface TreatmentGoalAddressesInput {
  conditionId?: string | null;
  conditionIcd10?: string | null;
}

export interface TreatmentGoalInput {
  startDate?: any | null;
  dueDate?: any | null;
  statusReason?: string | null;
  continuous?: boolean | null;
  note?: string | null;
  description: string;
  goalStatus: string;
  achievementStatus: GoalAchievementStatus;
  category: GoalCategory;
  priority: GoalPriority;
  patientId: string;
  target: GoalTargetInput;
  addresses: TreatmentGoalAddressesInput;
}

export interface TreatmentPlanCreateInput {
  plan: CarePlanCreateInput;
  conditions: TreatmentConditionsCreateInput[];
  team?: TreatmentTeamInput | null;
  goals?: TreatmentGoalInput[] | null;
}

export interface TreatmentTeamInput {
  organizationId?: string | null;
  name: string;
  category: CareTeamCategory;
  status?: CareTeamStatus | null;
  contactId?: string | null;
  conditionId?: string | null;
  period?: PeriodCreateInput | null;
  note?: string | null;
  subject: CarePlanSubjectInput;
  members?: CareTeamMemberCreateInput[] | null;
}

export interface UpdateCreditCardType {
  cardNumber?: string | null;
  expirationDate: string;
  cvv?: string | null;
}

export interface UpdateUserPasswordInput {
  password: string;
  newPassword: string;
}

export interface UpdateUserProfilesInput {
  cynergyId?: string | null;
  username?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  phone?: string | null;
  email?: string | null;
  name?: string | null;
  dob?: any | null;
  twoFactorEnabled?: boolean | null;
  alias?: string | null;
  npiNumber?: string | null;
  cliaNumber?: string | null;
  colaNumber?: string | null;
  password?: string | null;
}

export interface UserAddressDataInput {
  addressId?: string | null;
  nickname?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  formattedAddress?: string | null;
  lat?: number | null;
  lng?: number | null;
  placeId?: string | null;
  replacementId?: string | null;
  isDefault: boolean;
}

export interface UserAddressInput {
  addressId?: string | null;
  userId?: string | null;
  replacementId?: string | null;
  nickname?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  formattedAddress?: string | null;
  lat?: number | null;
  lng?: number | null;
  placeId?: string | null;
  type?: string | null;
  use?: string | null;
  isDefault?: boolean | null;
}

export interface UserCartItemInput {
  collectionDayTimeBlockID: string;
}

export interface UserContactData {
  contactId?: string | null;
  userId?: string | null;
  contactRelationId?: string | null;
  nickname?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  phone?: string | null;
  email?: string | null;
  authorizedAccess?: boolean | null;
  contactTypeId?: string | null;
  contactRelationTypeId?: string | null;
}

export interface UserDependentData {
  patientId?: string | null;
  userId?: string | null;
  parentId?: string | null;
  username?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  phone?: string | null;
  dob?: string | null;
  userConsent?: boolean | null;
  gender?: string | null;
  maritalStatus?: string | null;
  permissionId?: string | null;
}

export interface VerificationCodeRequest {
  to: string;
  channel: string;
  local?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
